/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_Top_UpsInputs */

const id_staff_nav_top_ups = /** @type {(inputs: Staff_Nav_Top_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-up`)
};

const en_staff_nav_top_ups = /** @type {(inputs: Staff_Nav_Top_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-ups`)
};

/**
* | output |
* | --- |
* | "Top-ups" |
*
* @param {Staff_Nav_Top_UpsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_top_ups = /** @type {((inputs?: Staff_Nav_Top_UpsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_Top_UpsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_top_ups(inputs)
	return id_staff_nav_top_ups(inputs)
});